import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = { contentId: String }

  connect() {
    const contentEl = document.getElementById(this.contentIdValue);
    
    this.popover = new bootstrap.Popover(this.element, {
      html: true,
      content: contentEl ? contentEl.innerHTML : '',
      trigger: 'manual',
      placement: 'auto',
      customClass: 'calendar-popover-custom',
      // 💡 重要: ポップオーバーの挿入先をbodyではなく親要素にするか、
      // あるいは遷移時に確実に消えるように設定します。
      container: 'body' 
    });

    this.initEvents();
  }

  initEvents() {
    // 💡 他のポップオーバーを閉じるためのイベント
    this._hideOthers = () => this.hidePopover();
    document.addEventListener('calendar-popover:hide-all', this._hideOthers);

    // モバイル：タップ制御
    this.element.addEventListener('click', (e) => {
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        e.stopPropagation();
        this.showPopover();
      }
    });

    // PC：ホバー制御
    this.element.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: hover)').matches) {
        this.showPopover();
      }
    });

    this.element.addEventListener('mouseleave', (event) => {
      if (window.matchMedia('(hover: hover)').matches) {
        this._leaveTimeout = setTimeout(() => {
          this.hidePopover();
        }, 150);
      }
    });

    // 外側タップで閉じる（グローバル登録を一度だけに制御）
    this._externalClick = (e) => {
      if (!this.element.contains(e.target) && !e.target.closest('.popover')) {
        this.hidePopover();
      }
    };
    document.addEventListener('click', this._externalClick);
  }

  showPopover() {
    // 💡 他の全てのポップオーバー・インスタンスに「閉じろ」という通知を送る
    const event = new CustomEvent('calendar-popover:hide-all');
    document.dispatchEvent(event);

    this.popover.show();
  }

  hidePopover() {
    if (this.popover) {
      this.popover.hide();
    }
  }

  // 💡 Turbo遷移時や要素削除時に確実に掃除する
  disconnect() {
    if (this._leaveTimeout) clearTimeout(this._leaveTimeout);
    
    document.removeEventListener('calendar-popover:hide-all', this._hideOthers);
    document.removeEventListener('click', this._externalClick);

    if (this.popover) {
      // 💡 hide() してから dispose() しないと、DOMに要素が残るケースが多い
      this.popover.hide();
      this.popover.dispose();
      
      // 💡 強制削除: 万が一 .popover 要素が残っていたら物理的に消す
      document.querySelectorAll('.popover.show').forEach(el => el.remove());
    }
  }
}